import React, { ReactNode, ReactElement } from 'react'
import Box from '@mui/material/Box'

type ApplicationProps = {
  AppComponent: React.ComponentType<any>
  SidebarComponent?: React.ComponentType<any>
  ContextProviders?: React.ComponentType<{ children: ReactNode }>[]
  tab?: number
}

function RecursiveWrapper({
  components,
  children,
}: {
  components: React.ComponentType<{ children: ReactNode }>[]
  children: ReactNode
}): ReactElement {
  if (components.length === 0) return <>{children}</>

  const [CurrentProvider, ...remainingProviders] = components

  return (
    <CurrentProvider>
      <RecursiveWrapper components={remainingProviders}>{children}</RecursiveWrapper>
    </CurrentProvider>
  )
}

function Application({ AppComponent, ContextProviders = [] }: ApplicationProps) {
  return (
    <RecursiveWrapper components={ContextProviders}>
      {
        <Box
          display="flex"
          flexDirection="column"
          height={'100%'}
          width={'100%'}
          overflow={'hidden'}
        >
          <AppComponent />
        </Box>
      }
    </RecursiveWrapper>
  )
}

export default Application
